<div class="anpp content">
  <div class="content-panel border-radius">
    <div class=" border-radius text-center" style="background:#fff">
      <div class="row">
        <div class="col-lg text-start ps-4 pt-4">
          <div class="row">
            <div class="col-lg-2 ps-4 pointer" [routerLink]="['./new']">
              <span style="text-decoration:underline">
                <fa-icon icon="plus-square"></fa-icon> Ajouter un clone
              </span>
            </div>
            <div class="col-lg-2 ps-4 pointer" [routerLink]="['/main/admin/listes']">
              <span style="text-decoration:underline">
                <fa-icon icon="clipboard-list"></fa-icon> Retour sur les listes
              </span>
            </div>
          </div>
        <div class="tableScroll tableScroll-param-height">
        <table class="table table-striped" aria-label="Liste des clones" *ngIf="varietes?.length > 0;">
          <thead class="sticky-top">
            <tr class="d-flex">
              <th class="col-lg-2" scope="col">Opérations</th>
              <th class="col-lg-3" scope="col" >Code</th>
              <th class="col-lg-3" scope="col">Libellé</th>
              <th class="col-lg-3" scope="col">Variété</th>
            </tr>
          </thead>
          <tbody>
              <tr class="d-flex" *ngFor="let variete of varietes ">
                <td class="col-lg-2">
                  <div class="btn-group dropright  ">
                    <div ngbDropdown placement="right-start">
                      <button class="btn btn-secondary dropdown-toggle btnprimary btn-sm " id="dropdownConfig"
                        ngbDropdownToggle>
                        <fa-icon icon="cog"></fa-icon>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                        <button (click)="editVariete(variete)" ngbDropdownItem class="dropdown-item" translate>
                          <fa-icon icon="id-card"></fa-icon>
                          label.modifier
                        </button>
                        <button (click)="openConfirmationDialog(variete)" ngbDropdownItem class="dropdown-item">
                          <fa-icon icon="trash"></fa-icon>
                          Supprimer
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="col-lg-3">{{ variete.code }}</td>
                <td class="col-lg-3">{{ variete.libelle }}</td>
                <td class="col-lg-3">{{ variete.varieteClone.libelle }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      </div>

    </div>
  </div>
</div>
